var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddPlaylist = function SvgAddPlaylist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M.916 2.103 2.142.876h14.716l1.226 1.227v21.773L9.5 18.79.916 23.876V2.103Zm1.226 0v19.773l7.358-4.5 7.358 4.5V2.103H2.142Z"
  })));
};
export default SvgAddPlaylist;